document.addEventListener("DOMContentLoaded", () => {
  const measurementTables = document.querySelectorAll(".guide-table");
  const sizeToggle = document.querySelector(".toggle");
  const sizeSlider = document.querySelector(".slider");

  const convertMeasurementUnits = (value, convertToCentimeters) => {
    // Split the value by ' - ' in case it is a range
    const values = value.split(" - ").map((val) => val.trim());

    // Convert and format each value
    return values
      .map((originalValue) => {
        if (originalValue === "" || originalValue === "-") return originalValue;

        // Convert the value
        let convertedValue = convertToCentimeters ? parseFloat(originalValue) * 2.54 : parseFloat(originalValue);

        // Round to 1 decimal place
        convertedValue = parseFloat(convertedValue.toFixed(1));

        // Remove the .0 if present
        return convertedValue.toString().endsWith(".0") ? convertedValue.toString().slice(0, -2) : convertedValue;
      })
      .join(" - ");
  };

  const updateMeasurementTableUnits = (convertToCentimeters) => {
    measurementTables.forEach((table) => {
      const tableHeaders = table.querySelectorAll("thead th");
      const tableRows = table.querySelectorAll("tbody tr");

      tableHeaders.forEach((header, index) => {
        const isInchesHeader = header.innerText.includes("IN");
        const isCentimetersHeader = header.innerText.includes("CM");

        if (isInchesHeader || isCentimetersHeader) {
          tableRows.forEach((row) => {
            const tableCell = row.querySelectorAll("td")[index];

            if (!tableCell.dataset.originalInches) {
              tableCell.dataset.originalInches = tableCell.innerText;
            }

            const measurementAfterConversion = updateHeaderAndConvert(
              header,
              tableCell,
              convertToCentimeters,
              isInchesHeader,
              isCentimetersHeader
            );

            tableCell.innerText = measurementAfterConversion;
          });
        }
      });
    });
  };

  const updateHeaderAndConvert = (header, tableCell, convertToCentimeters, isInchesHeader, isCentimetersHeader) => {
    let measurementAfterConversion;
    if ((convertToCentimeters && isInchesHeader) || (!convertToCentimeters && isCentimetersHeader)) {
      measurementAfterConversion = convertMeasurementUnits(tableCell.dataset.originalInches, convertToCentimeters);
      header.innerText = header.innerText.replace(
        convertToCentimeters ? "IN" : "CM",
        convertToCentimeters ? "CM" : "IN"
      );
    } else {
      measurementAfterConversion = tableCell.innerText;
    }
    return measurementAfterConversion;
  };

  sizeToggle.addEventListener("change", (event) => {
    const convertToCentimeters = event.target.id === "cm";
    sizeSlider.style.transform = convertToCentimeters ? "translateX(100%)" : "translateX(0)";
    updateMeasurementTableUnits(convertToCentimeters);
  });
});
